import React, { FunctionComponent, useEffect, useState } from 'react';
import { RootState } from '../../app/store';
import { connect, ConnectedProps } from 'react-redux';
import { useIntl } from 'react-intl';
import messages from './messages';
import { StyledTable, Wrap } from '../../assets/styledAssets/grid';
import {
  accentColorPrim,
  accentColorSecond,
  fontColorPrim,
  fontColorSecond,
  red,
  white,
} from '../../assets/styledAssets/vars';
import Button from '../../components/Button/Button.component';
import {
  DeleteIcon,
  PlusIcon,
  SomeIcon,
} from '../../components/Icons/Icons.component';
import { GridColumn } from '@progress/kendo-react-grid';
import Moment from 'react-moment';
import DialogWrap from '../../components/DiaogWrap/DiaogWrap.component';
import { Qualification, QualificationLevel } from './qualification';
import { StyledTD } from '../Questionnaires/QuestionnairesList/styles';
import UpgradeQualification from './components/UpgradeQualification/UpgradeQualification.component';
import QualificationDetails from './components/QualificationDetails/QualificationDetails.component';
import { setListQualifications } from './Qualification.slice';
import {
  deleteQualification,
  fetchListQualifications,
  updateQualification,
  upgradeQualification,
} from '../../service/Qualification.service';
import { StyledFormField } from '../../components/FormField/styles';
import { AutoCompleteChangeEvent } from '@progress/kendo-react-dropdowns';
import { DropdownResponse, Roles, User } from '../../domains/app';
import PersonsService from '../../service/Persons.service';
import ResultsService from '../../service/Results.service';
import { StyledAutoComplete } from './styles';

const connector = connect(
  (state: RootState) => ({
    listQualifications: state.qualification.listQualifications,
    profile: state.app.user,
    selectedAccount: state.app.selectedAccount,
  }),
  {
    setListQualifications,
  },
);

type PropsFromRedux = ConnectedProps<typeof connector>;

const QualificationContainer: FunctionComponent<PropsFromRedux> = ({
  listQualifications,
  setListQualifications,
  profile,
  selectedAccount,
}) => {
  const intl = useIntl();
  const [upgradeTestType, setUpgradeTestType] = useState<string | undefined>();
  const [showDetails, setShowDetails] = useState<boolean>();
  const [loadingUsers, setLoadingUsers] = useState<boolean>(false);
  const [listTestTypes, setListTestTypes] = useState<DropdownResponse[]>([]);
  const [selectedUser, setSelectedUser] = useState<User>(profile as User);
  const [listUsers, setListUsers] = useState<User[]>([]);
  const [selectedQualification, setSelectedQualification] = useState<
    Qualification
  >();

  useEffect(() => {
    ResultsService.fetchUserExercise([]).then((res) => {
      setListTestTypes(res);
    });
  }, []);

  useEffect(() => {
    fetchListQualifications(selectedUser?.id as string).then((res) => {
      setListQualifications(res);
    });
    // eslint-disable-next-line
  }, [selectedUser]);

  const upgradeToTester = (email: string, testTypeId: string) => {
    upgradeQualification(
      email,
      profile?.id as string,
      testTypeId,
      QualificationLevel.Tester,
    ).finally(() => setUpgradeTestType(undefined));
  };

  const updateQ = (q: Partial<Qualification>) => {
    if (q.id) {
      updateQualification(q as Qualification)
        .then((res) => {
          setListQualifications(
            listQualifications.map((qu) => {
              if (qu.id === q.id) {
                return res;
              }
              return qu;
            }),
          );
        })
        .finally(() => {
          setShowDetails(false);
          setSelectedQualification(undefined);
        });
    } else {
      upgradeQualification(
        selectedUser.email,
        profile?.id as string,
        q.testType?.id as string,
        q.level as QualificationLevel,
      )
        .then((res) => {
          setListQualifications(listQualifications.concat([res]));
        })
        .finally(() => {
          setShowDetails(false);
          setSelectedQualification(undefined);
        });
    }
  };

  const deleteQ = (id: string) => {
    deleteQualification(id).then(() => {
      setListQualifications(listQualifications.filter((qu) => qu.id !== id));
    });
  };

  const loadUsers = (e: AutoCompleteChangeEvent) => {
    const user = listUsers.find((u) => u.fullName === e.value);
    if (user) {
      setSelectedUser(user);
      return;
    }
    if (e.value.length >= 2) {
      setLoadingUsers(true);
      PersonsService.fetchListUser(100, 0, e.value)
        .then((res) => {
          res.items.forEach(
            (it) => (it.fullName = `${it.firstName} ${it.lastName}`),
          );
          setListUsers(res.items);
        })
        .finally(() => setLoadingUsers(false));
    } else {
      setListUsers([]);
    }
  };

  return (
    <Wrap flexDir={'column'} overflow={'auto'} flexWrap={'nowrap'}>
      <Wrap
        alignItems={['flex-start', 'center']}
        width={'100%'}
        margin={['0', '0 0 3rem']}
        flexDir={['column', 'row']}
        justifyCont={['flex-start', 'space-between']}
      >
        <Wrap
          alignItems={['flex-start', 'flex-end']}
          flexDir={['column', 'row']}
          margin={['0 0 2rem 0', '0']}
        >
          <Wrap
            fs={'3.2rem'}
            fw={'bold'}
            color={'#000'}
            alignItems={'flex-end'}
            borders={[
              [{ side: 'right', color: 'transparent' }],
              [{ side: 'right', color: accentColorSecond }],
            ]}
            padding={['0', '0 3rem 0 0']}
            margin={['0 0 2rem 0', '0 3rem 0 0']}
          >
            {intl.formatMessage(messages.title)}
          </Wrap>
          <Wrap
            fs={'1.8rem'}
            color={fontColorSecond}
            alignItems={'flex-end'}
            padding={'0 0 .5rem 0'}
          >
            {listQualifications.length} {intl.formatMessage(messages.total)}
          </Wrap>
        </Wrap>
        {selectedAccount &&
          !!(
            (selectedAccount.role as number) & Roles.Administrator ||
            (selectedAccount.role as number) & Roles.SiteOwner
          ) && (
            <Wrap
              margin={['0 0 2rem 0', '0']}
              justifyCont={['flex-start', 'flex-end']}
            >
              <Button primary onClick={() => setShowDetails(true)}>
                <PlusIcon color={white} width={'1.4rem'} />
                {intl.formatMessage(messages.addQualification)}
              </Button>
            </Wrap>
          )}
      </Wrap>
      {selectedAccount &&
        !!(
          (selectedAccount.role as number) & Roles.Administrator ||
          (selectedAccount.role as number) & Roles.SiteOwner
        ) && (
          <Wrap
            maxWidth={'34rem'}
            alignItems={'center'}
            margin={['0 0 2rem 0', '0 0 3rem 0']}
            width={'100%'}
          >
            <StyledFormField>
              <StyledAutoComplete
                data={listUsers}
                defaultValue={selectedUser.fullName}
                textField="fullName"
                onChange={(e) => loadUsers(e)}
                loading={loadingUsers}
                placeholder={intl.formatMessage(messages.search)}
              />
            </StyledFormField>
          </Wrap>
        )}

      <Wrap
        grow={'1'}
        padding={'0 1.5rem'}
        overflow={'hidden'}
        width={'100%'}
        height={'100%'}
        hiddenXS
      >
        <StyledTable
          style={{ height: '100%' }}
          data={listQualifications}
          onRowClick={(e) => {
            if ((selectedAccount?.role as number) & Roles.Administrator) {
              setShowDetails(true);
              setSelectedQualification(e.dataItem);
            }
          }}
        >
          <GridColumn
            field="level"
            title={intl.formatMessage(messages.title)}
            width={'150px'}
            cell={(props) => (
              <td>
                {props.dataItem.level === QualificationLevel.Tester
                  ? intl.formatMessage(messages.tester)
                  : intl.formatMessage(messages.instructor)}
              </td>
            )}
          />
          <GridColumn
            field="testType.name"
            title={intl.formatMessage(messages.test)}
            width={'150px'}
          />
          <GridColumn
            field="accreditedDate"
            title={intl.formatMessage(messages.date)}
            width={'150px'}
            cell={(props) => (
              <td>
                <Moment format={'DD MMM YYYY'}>
                  {props.dataItem.accreditedDate}
                </Moment>
              </td>
            )}
          />
          <GridColumn
            field="grantedByPerson"
            title={intl.formatMessage(messages.granted)}
            cell={(props) => (
              <td>
                {props.dataItem.grantedByPerson.firstName}{' '}
                {props.dataItem.grantedByPerson.lastName}
              </td>
            )}
          />
          <GridColumn
            field="grantedByPerson.email"
            title={intl.formatMessage(messages.email)}
          />
          <GridColumn
            cell={(props) => (
              <StyledTD>
                <Wrap width={'100%'} justifyCont={'flex-end'}>
                  {selectedAccount &&
                    !((selectedAccount.role as number) & Roles.Administrator) &&
                    props.dataItem.level === QualificationLevel.Instructor && (
                      <Button
                        transparent
                        icon
                        onClick={(e: MouseEvent) =>
                          setUpgradeTestType(props.dataItem.testTypeId)
                        }
                        children={
                          <SomeIcon width={'2rem'} color={accentColorPrim} />
                        }
                      />
                    )}
                  {selectedAccount &&
                    !!(
                      (selectedAccount.role as number) & Roles.Administrator
                    ) && (
                      <Button
                        icon
                        transparent
                        onClick={(e: any) => {
                          e.preventDefault();
                          deleteQ(props.dataItem.id);
                        }}
                      >
                        <DeleteIcon color={red} width={'2rem'} />
                      </Button>
                    )}
                </Wrap>
              </StyledTD>
            )}
          />
        </StyledTable>
      </Wrap>

      <Wrap hiddenSM overflow={'auto'} width={'100%'}>
        {listQualifications.map((qualification: any, index) => (
          <Wrap
            flexDir={'column'}
            flexWrap={'wrap'}
            margin={'0 0 2rem 0'}
            width={'100%'}
            padding={'3rem'}
            br={'1.2rem'}
            bgColor={white}
            key={`card-${index}`}
          >
            <Wrap
              width={'100%'}
              margin={'0 0 2rem 0'}
              justifyCont={'space-between'}
            >
              <Wrap flexDir={'column'}>
                <Wrap margin={'0 0 .6rem 0'} fs={'2rem'} fw={'bold'}>
                  {qualification.level === QualificationLevel.Tester
                    ? intl.formatMessage(messages.tester)
                    : intl.formatMessage(messages.instructor)}
                </Wrap>
                <Wrap fw={'bold'}>
                  {qualification.testType?.name
                    ? qualification.testType?.name
                    : '-'}
                </Wrap>
              </Wrap>
              <Wrap alignItems={'center'} justifyCont={'flex-end'}>
                {selectedAccount &&
                  !((selectedAccount.role as number) & Roles.Administrator) && (
                    <Button
                      transparent
                      icon
                      disabled={
                        qualification.level === QualificationLevel.Tester
                      }
                      onClick={(e: MouseEvent) =>
                        setUpgradeTestType(qualification.testTypeId)
                      }
                      children={
                        <SomeIcon width={'2rem'} color={accentColorPrim} />
                      }
                    />
                  )}
                {selectedAccount &&
                  !!(
                    (selectedAccount.role as number) & Roles.Administrator
                  ) && (
                    <Button
                      icon
                      transparent
                      onClick={(e: any) => {
                        e.preventDefault();
                        deleteQ(qualification.id);
                      }}
                    >
                      <DeleteIcon color={red} width={'2rem'} />
                    </Button>
                  )}
              </Wrap>
            </Wrap>
            <Wrap alignItems={'center'} margin={'0 0 2rem 0'} width={'100%'}>
              <Wrap
                fs={'1.5rem'}
                flexDir={'column'}
                margin={'0 1.6rem 0 0'}
                padding={'0 1.6rem 0 0'}
                borders={[{ side: 'right' }]}
              >
                <Wrap
                  fs={'1.4rem'}
                  color={fontColorSecond}
                  margin={'0 0 1rem 0'}
                >
                  {intl.formatMessage(messages.granted)}
                </Wrap>
                <Wrap fw={'bold'} color={fontColorPrim} margin={'0 .6rem 0 0'}>
                  {' '}
                  {qualification.grantedByPerson.firstName}{' '}
                  {qualification.grantedByPerson.lastName}
                </Wrap>
              </Wrap>
              <Wrap flexDir={'column'}>
                <Wrap
                  fs={'1.4rem'}
                  color={fontColorSecond}
                  margin={'0 0 1rem 0'}
                >
                  {intl.formatMessage(messages.date)}
                </Wrap>
                <Wrap color={fontColorPrim}>
                  <Moment format={'MM/DD/YY'}>
                    {qualification.accreditedDate}
                  </Moment>
                </Wrap>
              </Wrap>
            </Wrap>
            <Wrap alignItems={'center'}>
              <Wrap color={fontColorSecond}>
                {qualification.grantedByPerson?.email}
              </Wrap>
            </Wrap>
          </Wrap>
        ))}
      </Wrap>

      {!!upgradeTestType && (
        <DialogWrap
          title={intl.formatMessage(messages.upgradeToTester)}
          children={
            <UpgradeQualification
              testTypeId={upgradeTestType}
              onSave={upgradeToTester}
              onCancel={() => setUpgradeTestType(undefined)}
            />
          }
        />
      )}
      {showDetails && (
        <DialogWrap
          title={intl.formatMessage(messages.upgradeToTester)}
          children={
            <QualificationDetails
              testTypeList={listTestTypes.filter(
                (t) =>
                  !listQualifications.map((q) => q.testTypeId).includes(t.id),
              )}
              onSave={updateQ}
              onCancel={() => {
                setShowDetails(false);
                setSelectedQualification(undefined);
              }}
              qualification={selectedQualification}
            />
          }
        />
      )}
    </Wrap>
  );
};

export default connector(QualificationContainer);
